import instance from 'api';
import { IJsonStorageType, IReport } from './interface';

export const getMyPositions = () => {
  return instance()
    .post('/users/listPositions')
    .then((response) => response.data);
};

export const getReports = () => {
  return instance()
    .post<IReport[]>('/jsonStorage/list', { isPublic: true, isReport: true })
    .then((response) => response.data);
};

export const getJsonStorageTypes = () => {
  return instance()
    .post<IJsonStorageType[]>('/jsonStorage/types', {})
    .then((response) => response.data);
};

export const getClosedApplicationsByOperators = () => {
  return instance()
    .post('/application/callCenterClosed')
    .then((response) => response.data);
};

export const getClosedApplicationsByOperatorsExcel = () => {
  return instance()
    .post('/application/callCenterClosedExcel', null, { responseType: 'blob' })
    .then((response) => response.data);
};

export const getOpenApplicationsByOperators = () => {
  return instance()
    .post('/application/callCenterOpen')
    .then((response) => response.data);
};

export const getOpenApplicationsByOperatorsExcel = () => {
  return instance()
    .post('/application/callCenterOpenExcel', null, {
      responseType: 'blob',
    })
    .then((response) => response.data);
};
